import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { NewBankAccount } from 'app/models/dto/bank-account.model';

@Component({
  selector: 'app-bank-account-add',
  templateUrl: './bank-account-add.component.html',
  styleUrls: ['./bank-account-add.component.scss'],
  standalone: false
})
export class BankAccountAddComponent implements OnInit {

  @Input() borrowerId: number;
  @Input() showCancel = true;
  @Output() addAccount = new EventEmitter<NewBankAccount>();
  @Output() cancel = new EventEmitter<void>();

  saving = false;
  form = new UntypedFormGroup({});
  model: {
    borrowerId: number;
    accountNumber: null | string;
    accountType: null | string;
  };
  fields: FormlyFieldConfig[] = [
    {
      key: 'accountNumber',
      type: 'text',
      templateOptions: {
        label: 'Account Number',
        required: true,
      }
    },
    {
      key: 'accountType',
      type: 'select',
      templateOptions: {
        label: 'Account Type',
        required: true,
        options: [
          { label: 'Checking', value: 'checking' },
          { label: 'Savings', value: 'savings' },
        ],
      }
    }
  ];

  constructor() { }

  ngOnInit(): void {
    this.model = {
      borrowerId: this.borrowerId,
      accountNumber: null,
      accountType: null,
    };
  }

  onSubmit(newBankAccount) {
    if (!this.form.valid) {
      return;
    }
    this.saving = true;
    // if the form is valid, we know it's compatible with NewBankAccount
    this.addAccount.emit(newBankAccount as NewBankAccount);
  }

  onCancel() {
    if (this.saving) {
      return;
    }
    this.cancel.emit();
  }
}
